<div class="register-page" [class.register-page-active]="!openedAsDialog">
  <div class="register-container" [class.mat-dialog-container]="openedAsDialog" [class.auth-card]="!openedAsDialog">
  <h2 mat-dialog-title id="register-dialog-title" class="dialog-title" [class.register-card-title]="!openedAsDialog">
    <span class="title-text">Register</span>
    <button mat-icon-button type="button" class="close-icon" id="register-dialog-close-button" *ngIf="openedAsDialog" (click)="close()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content [class.register-card-content]="!openedAsDialog">
    <div class="notice notice-error" *ngIf="error">
      <div class="notice-body">Failed to register user<br>{{ error?.description }}</div>
    </div>
    <div class="notice" *ngIf="invite && !success">
      <div class="notice-body">
        You have been invited to contract {{ invite.contractNo }} by {{ invite.invitedByEmail || 'Cristie Software' }}.
      </div>
    </div>
    <div class="notice" *ngIf="success">
      <div class="notice-body">{{ inviteToken ? 'Contract access accepted' : 'Registration successful' }}</div>
    </div>

    <div class="notice" *ngIf="invite?.existingUser && !success && !accepting">
      <div class="notice-body">This email already has a portal account. Login to accept the contract invitation.</div>
    </div>

    <form [formGroup]="RegisterForm" *ngIf="RegisterForm && !success && !invite?.existingUser" class="material-form-grid">
      <mat-form-field appearance="fill">
        <mat-label>Username</mat-label>
        <input matInput id="userName" formControlName="userName" />
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Email</mat-label>
        <input matInput id="email" type="email" formControlName="email" />
      </mat-form-field>
      <app-all-seeing-eye label="Password" formControlName="password"></app-all-seeing-eye>
      <app-all-seeing-eye label="Confirm Password" formControlName="confirm"></app-all-seeing-eye>
      <mat-form-field appearance="fill">
        <mat-label>Password Reset Question</mat-label>
        <input matInput id="resetQuestion" formControlName="resetQuestion" />
      </mat-form-field>
      <app-all-seeing-eye label="Password Reset Answer" formControlName="resetAnswer"></app-all-seeing-eye>
      <mat-form-field appearance="fill" *ngIf="!inviteToken">
        <mat-label>Contract/Agreement No</mat-label>
        <input matInput id="agreement" type="number" formControlName="contractNo" min="0" step="1" max="9999" />
      </mat-form-field>
      <app-all-seeing-eye *ngIf="!inviteToken" label="Contract Password" formControlName="contractPassword" class="full-width"></app-all-seeing-eye>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end" [class.register-card-actions]="!openedAsDialog">
    <ng-container *ngIf="!success; else registerSuccessActions">
      <button mat-raised-button color="accent" id="register-cancel-button" type="button" (click)="close()">Cancel</button>
      <button mat-raised-button color="primary" id="register-login-invite-button" type="button" *ngIf="invite?.existingUser"
        (click)="loginForInvite()">Login</button>
      <button mat-raised-button color="primary" id="register-submit-button" type="button" (click)="registerUser()"
        [disabled]="registerDisabled()" *ngIf="!invite?.existingUser">
        <mat-spinner *ngIf="registering" diameter="20" mode="indeterminate"></mat-spinner>
        {{ registering ? 'Registering' : 'Register' }}
      </button>
    </ng-container>
  </mat-dialog-actions>

  <ng-template #registerSuccessActions>
    <mat-dialog-actions align="end" [class.register-card-actions]="!openedAsDialog">
      <button mat-raised-button color="accent" id="register-back-login-button" type="button" (click)="close()">Close</button>
    </mat-dialog-actions>
  </ng-template>
  </div>
</div>
